import { LambdaSchema } from "./types";

const schema: LambdaSchema = {
  columns: [
    { key: "platform", label: "platform" },
    { key: "conversation_id", label: "conversation_id" },
    { key: "job_name", label: "job_name" },
    { key: "service_whisper_total", label: "whisper_total" },
    { key: "service_deepgram_total", label: "deepgram_total" },
    { key: "service_chunks_count", label: "chunks_count" },
    { key: "audio_length_seconds", label: "audio_length_seconds" },
    { key: "transcription_duration_ms", label: "transcription_duration_s", transform: "secondsFromMs" },
    { key: "transcript_language", label: "transcript_language" },
    { key: "transcript_length_chars", label: "transcript_length_chars" }
  ],
};

export default schema;

